module.exports = __webpack_public_path__ + "static/media/empty_contacts.b25bc9a7.svg";